const textCarousel = () => {
    window.addEventListener("load", () => {
      document.fonts.ready.then(() => {
        const blocks = document.querySelectorAll(".text-carousel__section");
        if (!blocks.length) return;
  
        blocks.forEach((block) => {
          const items = [...block.querySelectorAll(".text-carousel__item")];
          if (!items.length) return;

          let totalWidth = 0;
  
          items.forEach((item) => {
            let width = item.clientWidth;
            gsap.set(item, { x: totalWidth, y: 0 });
            totalWidth += width;
          });
  
          items.forEach((item) => {
            const itemWidth = item.clientWidth;
            
            gsap.to(item, {
              duration: 12 * items.length,
              ease: "none",
              x: `-=${totalWidth}`,
              modifiers: {
                x: gsap.utils.unitize((x) => {
                  let pos = parseFloat(x);
                  return pos <= -itemWidth ? pos + totalWidth : pos;
                }),
              },
              repeat: -1,
            });
          });
        });
      });
    });
  };
  
  export default textCarousel;
  